import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  warningIcon: {
    color: theme.palette.warning?.main || "#f0ad4e"
  },
  termLine: {
    marginBottom: theme.spacing(1)
  },
  term: {
    fontWeight: "bold"
  },
  replacement: {
    fontWeight: "bold"
  }
}));

const ForbiddenWordWarningModal = ({
  open,
  matches = [],
  onClose,
  onReplace,
  onSendAnyway
}) => {
  const classes = useStyles();

  const hasReplacements = matches.some(m => m.replacement);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="forbidden-word-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="forbidden-word-dialog" disableTypography>
        <Typography variant="h6" className={classes.title}>
          <WarningIcon className={classes.warningIcon} />
          {i18n.t("forbiddenWordWarning.title")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {matches.map(match => (
          <Typography key={match.term} className={classes.termLine}>
            {i18n.t("forbiddenWordWarning.usingWord")}{" "}
            <span className={classes.term}>"{match.term}"</span>
            {match.replacement ? (
              <>
                {i18n.t("forbiddenWordWarning.replaceWith")}{" "}
                <span className={classes.replacement}>
                  "{match.replacement}"
                </span>
                .
              </>
            ) : (
              <>{i18n.t("forbiddenWordWarning.avoid")}</>
            )}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} color="default">
          {i18n.t("common.cancel")}
        </Button>
        {hasReplacements && (
          <Button variant="contained" onClick={onReplace} color="primary">
            {i18n.t("forbiddenWordWarning.replace")}
          </Button>
        )}
        <Button variant="contained" onClick={onSendAnyway} color="secondary">
          {i18n.t("forbiddenWordWarning.sendAnyway")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForbiddenWordWarningModal;
